import isValidCPF from "../helpers/Validators/isValidCPF";
import isValidCNPJ from "../helpers/Validators/isValidCNPJ";
import isValidEmail from "../helpers/Validators/isValidEmail";
import isValidCRM from "../helpers/Validators/isValidCRM";
import isValidRG from "../helpers/Validators/isValidRG";

export default class ValidationBase {

    Message: string;
    Validation: ValidationType;

    constructor(Message: string, Validation: ValidationType) {
        this.Message = Message;
        this.Validation = Validation;
    }
}

export enum ValidationType {
    CPF,
    CNPJ,
    TELEFONE,
    CELULAR,
    OBRIGATORIO,
    EMAIL,
    CEP,
    ANEXO_OBRIGATORIO,
    CRM,
    DATA,
    DATANASCIMENTO,
    RG,
    CUSTOM
}

export function ValidateUtil(ValidationTypeParam: ValidationType, Value: any, callBackCustomValidation: (Value: any) => string): string {

    switch (ValidationTypeParam) {
        case ValidationType.OBRIGATORIO:
            if (Value == null || Value === "") {
                return "O Campo é obrigatório."
            }
            break;
        case ValidationType.CPF:
            if (isValidCPF(Value) === false) {
                return "O CPF Informado é inválido."
            }
            break;

        case ValidationType.CNPJ:
            if (isValidCNPJ(Value) === false) {
                return "O CNPJ Informado é inválido."
            }
            break;

        case ValidationType.CELULAR:
            if (Value != null && Value !== "") {

                if (Value.replace("+", "").length >= 2) {
                    let ddi = Value.replace("+", "")[0] + Value.replace("+", "")[1];
                    if (ddi === 55 || ddi === "55") {
                        if (Value.replace(/\D/g, "").length < 13) {
                            return "O Celular Informado é inválido."
                        }
                    }
                    if (ddi != null && ddi.toString().length <= 1) {
                        return "O Celular Informado é inválido."
                    }
                }

                if (Value.toString().replace("+", "").length <= 10) {
                    return "O Celular Informado é inválido."
                }
            }
            break;

        case ValidationType.TELEFONE:
            if (Value != null && Value !== "") {

                if (Value.replace("+", "").length >= 2) {
                    let ddi = Value.replace("+", "")[0] + Value.replace("+", "")[1];
                    if (ddi === 55 || ddi === "55") {
                        if (Value.replace(/\D/g, "").length < 12) {
                            return "O Telefone Informado é inválido."
                        }
                    }
                    if (ddi != null && ddi.toString().length <= 1) {
                        return "O Telefone Informado é inválido."
                    }
                }

                if (Value.toString().replace("+", "").length <= 9) {
                    return "O Telefone Informado é inválido."
                }
            }
            break;

        case ValidationType.EMAIL:
            if (isValidEmail(Value) === false) {
                return "O Email informado é inválido."
            }
            break;

        case ValidationType.ANEXO_OBRIGATORIO:
            if (Value == null || Value === "" || Value.length === 0) {
                return "O anexo é obrigatório."
            }
            break;

        case ValidationType.CRM:
            if (Value == null || Value === "" || Value.length === 0) {
                return "O Conselho é obrigatório."
            } else if (isValidCRM(Value) === false) {
                return "O Conselho informado é inválido."
            }
            break;

        case ValidationType.DATA:
            if (Value != null || Value !== "" || Value.length !== 0) {

                if (Object.prototype.toString.call(Value) === "[object Date]") {
                    if (isNaN(Value)) {
                        return "A data informada é inválida."
                    }
                }
            }
            break;

        case ValidationType.DATANASCIMENTO:
            if (Value != null || Value !== "" || Value.length !== 0) {
                if (Value > new Date()) {
                    return "Data maior que a data limite"
                }
            }
            break;

        case ValidationType.RG:
            if (Value == null || Value === "" || Value.length === 0) {
                return "O RG é obrigatório."
            } else if (isValidRG(Value) === false) {
                return "O RG informado é inválido."
            }
            break;

        case ValidationType.CUSTOM:
            let result = callBackCustomValidation(Value);
            return result;

        default:
            break;
    }

    return "";
}